import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaqSupportButtonsComponent } from './faq-support-buttons.component';
import { IconsModule } from 'src/app/icons/icons.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { FaqSectionModule } from '../faq-section/faq-section.module';


@NgModule({
  declarations: [
    FaqSupportButtonsComponent
  ],
  imports: [
    CommonModule,
    IconsModule,
    SharedModule,
    RouterModule,
    FaqSectionModule
  ],
  exports: [
    FaqSupportButtonsComponent
  ]
})
export class FaqSupportButtonsModule { }